import React from 'react';
import { Box } from '@mui/material';
import {
  FlightTakeoff,
  Business,
  Assignment,
  Warning,
  WbSunny,
  Map,
  Security,
  Description,
  Abc,
  Movie
} from '@mui/icons-material';
import Pilot from "../Components/Pilot/Pilot.jsx";
import Brent from "../Components/Brent/Brent.jsx";
import ResourceSidebar from "../Components/ResourceSidebar/ResourceSidebar.jsx";

const Resources = () => {
  const companySections = [
    {
      title: "Brent",
      description: "Ressurser og lenker for Brent",
      icon: <Business />,
      path: null,
      component: "brent"
    },
    {
      title: "Pilot Space",
      description: "Flyoperasjoner, sjekklister og pilotressurser",
      icon: <FlightTakeoff />,
      path: "/pilot/plan",
      component: "pilot"
    }
  ];

  const alert = {
    severity: "warning",
    title: "Nye NINOX Prosedyrer",
    message: "Oppdaterte prosedyrer for NINOX i Tromsø fra 26. mai 2023"
  };

  const quickResources = [
    {
      title: "Viktige Ressurser",
      items: [
        {
          icon: <Assignment />,
          primary: "Mission Form Control (MFC)",
          secondary: "Påkrevd før flyging",
          href: "https://form.jotform.com/213212604878354",
          external: true
        },
        {
          icon: <Security />,
          primary: "Job Safety Analysis (JSA)",
          secondary: "Sikkerhetsvurdering",
          href: "https://form.jotform.com/213192990452357",
          external: true
        },
        {
          icon: <Map />,
          primary: "Safetofly.no",
          secondary: "Sjekk naturreservat og andre restriksjoner",
          href: "https://www.safetofly.no/",
          external: true
        }
      ]
    },
    {
      title: "Hurtiglenker",
      items: [
        {
          icon: <Movie />,
          primary: "Legg til prosjekter på hjemmesiden",
          secondary: "Last opp en video og publiser prosjektsiden på motion-air-site",
          path: "/resources/new-work"
        },
        {
          icon: <WbSunny />,
          primary: "Værmelding",
          secondary: "Sjekk værforhold",
          href: "https://www.yr.no",
          external: true
        },
        {
          icon: <Warning />,
          primary: "NOTAM",
          secondary: "Luftfartsmeldinger",
          href: "https://notams.aim.faa.gov/notamSearch/",
          external: true
        },
        {
          icon: <Description />,
          primary: "Dronelogbook",
          secondary: "Flylogg og vedlikehold",
          href: "https://www.dronelogbook.com",
          external: true
        },
        {
          icon: <Abc />,
          primary: "Fonetisk Alfabet",
          secondary: "NATO fonetisk alfabet",
          imageSrc: "/images/phonetic-alphabeth.png"
        }
      ]
    }
  ];

  const renderSection = (section) => {
    if (section.component === "brent") {
      return (
        <Box key={section.component} sx={{ mb: 3 }}>
          <Brent />
        </Box>
      );
    }

    if (section.component === "pilot") {
      return (
        <Box key={section.component}>
            <Pilot />
        </Box>
      );
    }

    return null;
  };

  return (
    <Box sx={{ 
      p: 3, 
      maxWidth: 1200, 
      margin: '0 auto',
      height: 'calc(100vh - 64px)',
      overflow: 'hidden',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      gap: 3,
    }}>
      <Box sx={{
        flex: { xs: '1 1 auto', md: '1 1 0' },
        minWidth: 0,
        minHeight: 0,
        overflowY: 'auto',
      }}>
        {companySections.map(section => renderSection(section))}
      </Box>

      <Box sx={{
        flex: { xs: '1 1 auto', md: '0 0 33%' },
        width: { md: '33%' },
        minWidth: 0,
        minHeight: 0,
        overflowY: 'auto',
      }}>
        <ResourceSidebar alert={alert} quickResources={quickResources} />
      </Box>
    </Box>
  );
};

export default Resources;

